import { ErrorWithData } from "cy-util/src/error/ErrorWithData";
import type { ApiResponseDetails } from "./models/ApiResponseDetails";
import type { ApiResponse } from "./models/ApiResponse";

/**
 * Creates a common plain data structure to hold api response which includes
 * trying to parse body as json, and falling back to text on failure.
 *
 * Any response that is not JSON throws an error.
 *
 * Any unhandled exception is returned in the error property.
 */
export async function parseJsonApiResponse(serverResponse: ApiResponse) {
  const { fetchResponse: response } = serverResponse;
  const log = serverResponse.toLogDataObject();
  const logData: ApiResponseDetails = {
    ...log,
  };

  try {
    const bodyText = await response.text();
    logData.body = bodyText;
    if (bodyText) {
      logData.body = JSON.parse(bodyText);
    }
  } catch (err) {
    if (err !== logData) {
      logData.error = err;
    }
    logData.ok = false;
  }

  if (!logData.ok) {
    throw new ErrorWithData("API call failed", logData);
  }

  return logData;
}

export type ApiResponseError = ErrorWithData<ApiResponseDetails>;
